import React from 'react';
import {
  NavigationButton,
  NavigationButtonText,
} from 'legacyComponents/buttons/styles';
import { media } from 'legacyComponents/styled/styleUtils';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { Icon } from 'components';

export const BackButton = withNamespaces()(({ onclick, hidden, small }) => (
  <Button onClick={onclick} hidden={hidden} small={small}>
    <Iconstyled name='arrow_left' />
    <Text>
      <Trans>back</Trans>
    </Text>
  </Button>
));

const Button = styled(NavigationButton)`
  position: absolute;
  top: 24px;
  left: ${props => (props.small ? '5px' : 'initial')};
  display: ${props => (props.hidden ? 'none' : 'block')};
  &:hover {
    > span:nth-of-type(1) {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  ${media.s`
    transform: scale(0.8);
    left: ${props => (props.small ? '0px' : 'initial')};
  `};
`;

const Iconstyled = styled(Icon)`
  width: 26px;
  height: 26px;
`;

const Text = styled(NavigationButtonText)`
  color: ${props => props.theme.color.wfWhite};
  left: 21px;
  top: 25px;
`;

BackButton.propTypes = {
  onclick: PropTypes.func,
  hidden: PropTypes.bool,
  small: PropTypes.bool,
};
